
import vFooter from '../common/footer.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

import {posterList,shareTaskList,memberShareTaskList} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex:1,
isIndex:null,
posterData:'',
shareData:'',
myShareData:'',
noMore:false,
onFetching:false,
PrmPageNo:1,
shareTotalPage:1,
posterTotalPage:1,
myShareTotalPage:1,
miniprogram:localStorage.getItem("miniprogram")
}
},
activated() {
if (this.scrollTop) {
this.$refs.wrapper.scrollTop = this.scrollTop;
}








},
created:function(){
/***是否登录 begin**/
this._wxTool.auth();
var member= this._wxTool.getMember();
if(null==member ){
console.log('need login');
this.$router.push('login');
}
this._wxTool.setNoShare();
/***是否登录 end**/
this.$vux.loading.hide()
if(!member){
this.$router.push('login')
}
this.tabIndex = this.$route.query.tabIndex
if(this.$route.query.tabIndex==1){
this.getShareData()
}else if(this.$route.query.tabIndex==3){
this.getPosterData()
}else{
this.getMyShareData()
}
},
components:{
vFooter,
LoadMore,
Scroller
},
beforeRouteLeave(to,from,next){
if(to.name=='taskDetail'){
from.meta.keepAlive=true
}else{
from.meta.keepAlive=false
}
next()
},
methods: {
preview(imgurl){
this._wxTool.previewImage(imgurl);
},
tab(e){
let tabIndex = e;
if(tabIndex==this.tabIndex){
return
}
this.tabIndex=tabIndex ;
this.PrmPageNo = 1
this.onFetching =false
this.posterData = '';
this.shareData='';
this.myShareData='';
this.shareTotalPage = 1;
this.myShareTotalPage=1;
this.posterTotalPage = 1;
if(tabIndex==1){
this.getShareData()
}else if(tabIndex==2){
this.getMyShareData()
}else{
this.getPosterData()
}
},
tx(){
this.$router.push('extract')
},
onScrollBottom(){
if (this.onFetching) {

} else {

this.onFetching = true
let params = {
accessToken : this._wxTool.getAccessToken(),
}
if(this.tabIndex==3){
if(this.posterTotalPage==1){
return
}
if(this.posterTotalPage<=this.PrmPageNo){
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}

params.PrmPageNo=this.PrmPageNo+=1
posterList(params).then(res=>{
if(res.code == 0){
this.posterData = this.posterData.concat(res.data.memberProductPostList)
this.posterTotalPage = res.data.page.totalPage
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
setTimeout(() => {
if(res.data.page.totalPage>=this.PrmPageNo){
this.onFetching = false
}
}, 2000)
if(res.data.memberProductPostList.length<=0){
this.noMore = true
}
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}else if(this.tabIndex==1){
console.log(this.PrmPageNo)
if(this.shareTotalPage==1){
return
}
if( this.shareTotalPage<=this.PrmPageNo){
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}
params.PrmPageNo=this.PrmPageNo+=1
params.PrmItemsPerPage=5
shareTaskList(params).then(res=>{
if(res.code == 0){
this.shareData = this.shareData.concat(res.data.shareTaskList)
this.shareTotalPage = res.data.page.totalPage
this.$nextTick(() => {
this.$refs.onScrollShare.reset()
})
setTimeout(() => {
if(res.data.page.totalPage>=this.PrmPageNo){
this.onFetching = false
}
}, 2000)
if(res.data.shareTaskList.length<=0){
this.noMore = true
}
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}else{
console.log(this.PrmPageNo)
if(this.myShareTotalPage==1){
return
}
if(this.myShareTotalPage<=this.PrmPageNo){
console.log(this.myShareTotalPage,this.PrmPageNo)
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}
params.PrmPageNo=this.PrmPageNo+=1
params.PrmItemsPerPage=5
memberShareTaskList(params).then(res=>{
if(res.code == 0){
console.log(res);
this.myShareData = this.myShareData.concat(res.data.memberShareList)
this.myShareTotalPage = res.data.page.totalPage
this.$nextTick(() => {
this.$refs.onScrollMyShare.reset()
})
setTimeout(() => {
if(res.data.page.totalPage>=this.PrmPageNo){
this.onFetching = false
}
}, 2000)
if(res.data.memberShareList.length<=0){
this.noMore = true
}
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}

}
},
isShow(e,shareFlag){
let index = e,isIndex=this.isIndex
if(shareFlag==0)return
if(index==isIndex){
this.isIndex=null
return
}
this.isIndex=e
},
goTaskDetail(id,shareFlag,endDays,imgUrl,title){
console.log(endDays)
if(endDays<=0){
this.$vux.toast.text('亲~活动已结束，请试试其他活动吧！', 'middle')
return
}
this.$router.push({path:'/taskDetail',query:{shareTaskId:id,shareFlag:shareFlag,imgUrl:imgUrl,title:title}})
},
getShareData(){
let params = {
accessToken : this._wxTool.getAccessToken(),
PrmItemsPerPage:5
}
shareTaskList(params).then(res=>{
if(res.code == 0){
this.noMore = false
console.log(res);
this.shareData = res.data.shareTaskList
this.shareTotalPage = res.data.page.totalPage
if(!this.shareData[0]){
this.noMore = true
return
}
this.$nextTick(() => {
this.$refs.onScrollShare.reset({top: 0})
})

}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
},
getMyShareData(){
let params = {
accessToken : this._wxTool.getAccessToken(),
PrmItemsPerPage:5
}
memberShareTaskList(params).then(res=>{
if(res.code == 0){
console.log(res);
this.myShareData = res.data.memberShareList
this.myShareTotalPage = res.data.page.totalPage
this.noMore = false
if(!this.myShareData[0]){
this.noMore = true
return
}
this.$nextTick(() => {
console.log(111)
this.$refs.onScrollMyShare.reset({top: 0})
})
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
},
getPosterData(){
let params = {
accessToken : this._wxTool.getAccessToken()
}
posterList(params).then(res=>{
if(res.code == 0){
console.log(res);
this.posterData = res.data.memberProductPostList
this.posterTotalPage = res.data.page.totalPage
this.noMore = false
if(!this.posterData[0]){
this.noMore = true
return
}
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/fenxiang/fenxiang.vue